import { render, staticRenderFns } from "./RegistrationItem.vue?vue&type=template&id=f640f876&"
import script from "./RegistrationItem.vue?vue&type=script&lang=ts&"
export * from "./RegistrationItem.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationItem.vue?vue&type=style&index=0&id=f640f876&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports